/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.191.0-v202609092147-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqLogsApiClass {
 
   constructor() {}

  /**
   * @summary Download the log files in zipped form.
   * @param {string} [downloadLogsCookie] - The value to return as a cookie.
  */
  public downloadLogs(
    {
      downloadLogsCookie
    } : {
      downloadLogsCookie?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/logs/download`;

    const queryParams = {
      ['downloadLogsCookie']: downloadLogsCookie
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Get a list of available log files.
  */
  public getAvailableLogFiles(
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/logs`;



    return axiosInstance.request({
      method: 'get',
      url,
      ...restOverrides
    }) as AxiosPromise<Array<string>>;
  }

  /**
   * @summary Get a collection of log messages
   * @param {string} log - ID of the log to retrieve
   * @param {string} startTime - Starting time to filter log messages on.
   * @param {number} limit - The (soft) limit for the number of log messages to return.
   * @param {string} [endTime] - Ending time to filter log messages on. It will default to the current time if none is specified.
   * @param {string} [sorted=ASC] - Whether log messages should be sorted in ascending order, &#x27;ASC&#x27;, by their time or descending order, &#x27;DESC&#x27;.
   * @param {string} [level=DEBUG] - The minimum log level to include.
   * @param {string} [sourceContains] - A substring that the source field of the log messages must contain to be returned.
   * @param {string} [messageContains] - A substring that the message field of the log messages must contain to be returned.
  */
  public getLogs(
    {
      log,
      startTime,
      limit,
      endTime,
      sorted,
      level,
      sourceContains,
      messageContains
    } : {
      log: string,
      startTime: string,
      limit: number,
      endTime?: string,
      sorted?: string,
      level?: string,
      sourceContains?: string,
      messageContains?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (log === null || log === undefined) {
      throw new Error("'log' parameter required");
    }

    if (startTime === null || startTime === undefined) {
      throw new Error("'startTime' parameter required");
    }

    if (limit === null || limit === undefined) {
      throw new Error("'limit' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/logs/${encodeURIComponent(String(log))}`
      .replace('{log}', encodeURIComponent(String(log)));

    const queryParams = {
      ['startTime']: startTime,      ['endTime']: endTime,      ['limit']: limit,      ['sorted']: sorted,      ['level']: level,      ['sourceContains']: sourceContains,      ['messageContains']: messageContains
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<Array<models.LogMessage>>;
  }

  /**
   * @summary Send a support request along with the log files to Seeq.
  */
  public send(
    body: models.SupportRequestInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/logs/send`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.SupportRequestOutputV1>;
  }

  /**
   * @summary Upload log messages from a remote agent.
   * @param {string} log - ID of the log to upload
  */
  public uploadRemoteAgentLogs(
    body: Array<models.LogMessageInputV1>,
    {
      log
    } : {
      log: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (log === null || log === undefined) {
      throw new Error("'log' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/logs/remote-agent/${encodeURIComponent(String(log))}`
      .replace('{log}', encodeURIComponent(String(log)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<Array<models.LogMessageOutputV1>>;
  }

}


export const sqLogsApi = new sqLogsApiClass();

export type sqLogsApiEndpoints = {
  'downloadLogs': {
    method: 'get';
    path: '/logs/download';
    response: string;
  };
  'getAvailableLogFiles': {
    method: 'get';
    path: '/logs';
    response: Array<string>;
  };
  'getLogs': {
    method: 'get';
    path: '/logs/${encodeURIComponent(String(log))}';
    response: Array<models.LogMessage>;
  };
  'send': {
    method: 'post';
    path: '/logs/send';
    response: models.SupportRequestOutputV1;
  };
  'uploadRemoteAgentLogs': {
    method: 'post';
    path: '/logs/remote-agent/${encodeURIComponent(String(log))}';
    response: Array<models.LogMessageOutputV1>;
  };
};

type ApiDownloadLogsResponse = string;
export function DownloadLogsQueryKey(
  params: Parameters<typeof sqLogsApi.downloadLogs>[0],
) {
  return ['sqLogsApi', 'downloadLogs', params] as const;
}

export function useApiDownloadLogsQuery(
  params: Parameters<typeof sqLogsApi.downloadLogs>[0],
  options?: Omit<UseQueryOptions<ApiDownloadLogsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiDownloadLogsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: DownloadLogsQueryKey(params),
    queryFn: () =>
      sqLogsApi.downloadLogs(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetAvailableLogFilesResponse = Array<string>;
export function GetAvailableLogFilesQueryKey(
) {
  return ['sqLogsApi', 'getAvailableLogFiles'] as const;
}

export function useApiGetAvailableLogFilesQuery(
  options?: Omit<UseQueryOptions<ApiGetAvailableLogFilesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetAvailableLogFilesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetAvailableLogFilesQueryKey(),
    queryFn: () =>
      sqLogsApi.getAvailableLogFiles(requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetLogsResponse = Array<models.LogMessage>;
export function GetLogsQueryKey(
  params: Parameters<typeof sqLogsApi.getLogs>[0],
) {
  return ['sqLogsApi', 'getLogs', params] as const;
}

export function useApiGetLogsQuery(
  params: Parameters<typeof sqLogsApi.getLogs>[0],
  options?: Omit<UseQueryOptions<ApiGetLogsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetLogsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetLogsQueryKey(params),
    queryFn: () =>
      sqLogsApi.getLogs(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiSendResponse = models.SupportRequestOutputV1;
type ApisendMutationParams = Parameters<typeof sqLogsApi.send> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqLogsApi.send>;
type ApisendMutationVariables = models.SupportRequestInputV1;

export function useApiSendMutation(
  options?: Omit<UseMutationOptions<ApiSendResponse, AxiosError<SeeqErrorData>,
    ApisendMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiSendResponse, AxiosError<SeeqErrorData>,
  ApisendMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApisendMutationVariables) =>
      sqLogsApi.send(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiUploadRemoteAgentLogsResponse = Array<models.LogMessageOutputV1>;
type ApiuploadRemoteAgentLogsMutationParams = Parameters<typeof sqLogsApi.uploadRemoteAgentLogs> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqLogsApi.uploadRemoteAgentLogs>;

export function useApiUploadRemoteAgentLogsMutation(
  options?: Omit<UseMutationOptions<ApiUploadRemoteAgentLogsResponse, AxiosError<SeeqErrorData>,
    ApiuploadRemoteAgentLogsMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUploadRemoteAgentLogsResponse, AxiosError<SeeqErrorData>,
  ApiuploadRemoteAgentLogsMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiuploadRemoteAgentLogsMutationParams) =>
      sqLogsApi.uploadRemoteAgentLogs(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
